import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year1/Spring/PlaceValueWithin20/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'PlaceValueWithin20',
  field: 'Number',
  weeks: [1, 3],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/PlaceValueWithin20/1CountWithin20" */ './1CountWithin20'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/PlaceValueWithin20/2Understand10" */ './2Understand10'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/PlaceValueWithin20/3Understand1112And13" */ './3Understand1112And13'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/PlaceValueWithin20/4Understand1415And16" */ './4Understand1415And16'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/PlaceValueWithin20/5Understand1718And19" */ './5Understand1718And19'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/PlaceValueWithin20/6Understand20" */ './6Understand20'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/PlaceValueWithin20/7OneMoreAndOneLess" */ './7OneMoreAndOneLess'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/PlaceValueWithin20/8TheNumberLineTo20" */ './8TheNumberLineTo20'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/PlaceValueWithin20/9UseANumberLineTo20" */ './9UseANumberLineTo20'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/PlaceValueWithin20/10EstimateOnANumberLineTo20" */ './10EstimateOnANumberLineTo20'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/PlaceValueWithin20/11CompareNumbersTo20" */ './11CompareNumbersTo20'
        )
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/PlaceValueWithin20/12OrderNumbersTo20" */ './12OrderNumbersTo20'
        )
    })
  ]
});
export default Block;
